const initialState = {
    noData: false,
    quotesList: [],
    fetching: false,
    fetched: false,
    error: null
}

export function quotesReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_QUOTES_LIST_TOKEN":
        case "FETCH_QUOTES_LIST": {
            return { ...state, fetching: true, fetched: false, error: null }
        }
        case "FETCH_QUOTES_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }
        case "FETCH_QUOTES_LIST_FULFILLED": {
            action.payload.data.sort((a, b) => {
                if (a.createdDate < b.createdDate)
                    return 1
                else if (a.createdDate > b.createdDate)
                    return -1
                else
                    return 0
            })
            .map((quote) => {
                var date = new Date(quote.createdDate)
                quote.createdDateDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()
            });

            return { ...state, fetching: false, fetched: true, noData: action.payload.data.length == 0, quotesList: action.payload.data }
        }
        case "FETCH_QUOTE_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        default:
            return state
    }
}
